import Vue from 'vue'

// directive which make element sticky and inner scrollable
// example use element attribute: v-sticky="{ zIndex: 1, stickyTop: 80, disabled: false}"
const Sticky = {
  bind (el, binding, vnode) {
    if (el && binding.value.disabled === false) {
      el.classList.add('sticky-panel')
      el.style.position = 'sticky'
      el.style.top = binding.value.stickyTop + 'px'
      if (binding.value.height !== undefined) {
        el.style.height = binding.value.height
      } else {
        el.style.height = 'calc(100vh - ' + (binding.value.stickyTop) + 'px)'
      }
      el.style['z-index'] = binding.value.zIndex
      el.style['overflow-y'] = 'auto'
      el.style['overflow-x'] = 'hidden'
    }
  }
}

Vue.directive('sticky', Sticky)
